import React from 'react';
import { Link } from "react-router-dom";
import Auth from "../../services/Auth.service";
import { useTranslation } from "react-i18next";
import NavegacionFarms from "../../components/NavigableComponents/NavigableFarms";
import GroupFarmsListComponents from "../../components/GroupFarmsComponents/GroupFarmsListComponents";
export default function ListGroupFarms() {

    const { t } = useTranslation();

    return (
        <div>
            {Auth.isUserLoged ? <div>
                <br />
                <div className="container-fluid">
                    <div className="col-12 col-lg-11 mx-auto">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/Farms/'}>{t("Global_Label_Text_Farms")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/GroupFarms/'}>{t("Global_Label_Text_Groups")}</Link></li>
                                </ol>
                            </nav>
                            <NavegacionFarms />

                        </div>
                    </div>
                </div>

                <div>
                    <GroupFarmsListComponents />
                </div>

                <br />
            </div > : ""}
        </div>
    );

}
